
import Swiper from 'vux/src/components/swiper/swiper.vue'

import backToTop from '../common/backToTop.vue';
export default {
components: {
Swiper,
backToTop
},
data() {
return {
myBackToTopStyle: {
right: '100px',
bottom: '150px',
width: '40px',
height: '40px',
'border-radius': '20px',
'line-height': '40px',
background: '#fff'
},
currentPage: 1,
pageSize: 99,
dataList: [],
lastPage: false,
swiper_list: [
{
url: 'javascript:',
img: './static/images/swiper_img1.jpg',
},
{
url: 'javascript:',
img: './static/images/swiper_img2.jpg',
},
{
url: 'javascript:',
img: './static/images/swiper_img3.jpg',
}
],
swiper_index: 0,
CSRDialog: false
};
},
methods: {

swiper_onIndexChange(currentIndex) {
},
loadList(type, done) {
let that = this;
let searchItem = {
currentPage: that.currentPage,
pageSize: that.pageSize
};
that.$axios
.get('/api/v1.0/familyApp/goods', {
params: searchItem
})
.then(function (response) {
if (response.status == 200) {
let dataList = [];
response.body.storeGoodsList.forEach(item => {
var flag = true,
index = 0;
dataList.forEach((one, i) => {
if (one.key == item.isSuitKey) {
flag = false;
index = i;
}
});
item.poster = item.photo;
item.goodsName = item.goodsTitle;
if (flag) {
dataList.push({
key: item.isSuitKey,
value: item.isSuitValue,
goodsList: [item]
});
} else {
dataList[index].goodsList.push(item);
}
});
that.dataList = dataList;
} else if (response.status == 203) {
that.lastPage = true;
}
});
},

toDetail(item) {
this.$router.push('/mallGoodsDetail?backPath=' + this.$route.path + '&goodsId=' + item.goodsId);
},
submit(type_, goods) {
if (!sessionStorage.token) {
this.$store.state.APPPAGE.toLoginFunc();
return false;
}
if (type_ == 1) {
let that = this;
let orderCart = {
goodsId: goods.goodsId,
goodsAttributeId: goods.goodsAttributeId,
number: 1
};
let data = {
orderCart: JSON.stringify(orderCart),
shopperId: that.$store.state.userInfo.shopperId
};
that.$axios.post('/api/v1.0/lonbonShop/saveOrderCart', that.qs.stringify(data)).then(function (response) {
if (response.status == 200) {
that.$vux.toast.show({
text: '已加入购物车',
type: 'success'
});
that.$store.state.APPPAGE.getOrderCartNum();
}
});
} else {
goods.number = 1;
sessionStorage.readyBuyGoods = JSON.stringify([goods]);
this.$router.push('/settlement');
}
}
},
mounted() {
this.loadList();
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/goods/list.vue